"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcDatePicker = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var FaIcon_1 = require("../util/FaIcon");
var AcFormFieldBadge_1 = require("../form/AcFormFieldBadge");
var DateTime = require('react-datetime');
/**
 * Display datepicker for the selection of date
 *
 * If props are not defined, it will show an empty string.
 */
var AcDatePicker = function (props) {
    var _a = props.float, float = _a === void 0 ? true : _a, _b = props.align, align = _b === void 0 ? 'left' : _b, _c = props.dateFormat, dateFormat = _c === void 0 ? 'YYYY/MM/DD' : _c, _d = props.timeFormat, timeFormat = _d === void 0 ? 'HH:mm' : _d, inputProps = props.inputProps, remainingProps = __rest(props, ["float", "align", "dateFormat", "timeFormat", "inputProps"]);
    var renderInput = function (props) { return (
    // function clear() {
    //   props.onChange({ target: { value: '' } });
    // }
    react_1.default.createElement(react_bootstrap_1.InputGroup, null,
        react_1.default.createElement("input", __assign({}, props)),
        react_1.default.createElement(react_bootstrap_1.InputGroup.Append, null,
            timeFormat === false && (react_1.default.createElement(FaIcon_1.FaIcon, { icon: "far fa-calendar-alt", fixedWidth: true, className: "align-self-center ml-1 mr-2 fs-medium" })),
            dateFormat === false && (react_1.default.createElement(FaIcon_1.FaIcon, { icon: "far fa-clock", fixedWidth: true, className: "align-self-center ml-1 mr-2 fs-medium" })),
            (inputProps === null || inputProps === void 0 ? void 0 : inputProps.required) && (react_1.default.createElement("div", { className: "d-flex align-self-center m-2" },
                react_1.default.createElement(AcFormFieldBadge_1.AcFormFieldBadge, { type: "required" })))))); };
    return (react_1.default.createElement("div", { className: clsx_1.default({
            'ac-date-picker': true,
            'ac-date-picker-fixed': !float,
            'ac-date-picker-right': align === 'right',
        }) },
        react_1.default.createElement(DateTime, __assign({ locale: "ja" }, remainingProps, { inputProps: inputProps, timeFormat: timeFormat, dateFormat: dateFormat, renderInput: renderInput }))));
};
exports.AcDatePicker = AcDatePicker;
exports.AcDatePicker.displayName = 'AcDatePicker';
//# sourceMappingURL=AcDatePicker.js.map